$(function() {
  var $header       = $('.header');
  var $button       = $header.find('.header-button');
  
  $button.on('click', function (e) {
    e.preventDefault();
    $header.toggleClass('is-active');
  });
});
